import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBorderAll } from '@fortawesome/pro-light-svg-icons';

export default function ShadowsEmptyState() {
  return (
    <div className="shadows-empty-state">
      <FontAwesomeIcon icon={faBorderAll} />
      <h3>You don't have any grids yet!</h3>
    </div>
  );
}
